import { h } from "preact"
import { DISPLAY_LOCALE, DISPLAY_TIME_ZONE } from "../utils/time"

const parseTimeFromDate = (date: Date): string =>
    date.toLocaleString(DISPLAY_LOCALE, {
        timeZone: DISPLAY_TIME_ZONE,
        hour12: false,
        day: "numeric",
        month: "numeric",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    })

type PingTimeProps = {
    time?: string
}

export default function PingTime({ time }: PingTimeProps){
    return(
        <div>Čas pingnutí: {time ? parseTimeFromDate(new Date(time)) : "-"}</div>
    )
}
